// Utilidades para cotejar documentos con mascotas existentes (FASE 6).

const norm = (v) =>
  (v == null ? "" : String(v))
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

// El microchip se compara solo por dígitos/letras (ignorando espacios y guiones).
const normChip = (v) => (v == null ? "" : String(v).replace(/[^a-z0-9]/gi, "").toLowerCase());

const getVal = (obj, k) => (obj && obj[k] && obj[k].valor != null ? obj[k].valor : null);

// Extrae los datos de mascota del análisis de Gemini.
export const extractPetData = (analisis) => {
  const m = (analisis && analisis.mascota) || {};
  return {
    nombre: getVal(m, "nombre"),
    especie: getVal(m, "especie"),
    raza: getVal(m, "raza"),
    sexo: getVal(m, "sexo"),
    fecha_nacimiento: getVal(m, "fecha_nacimiento"),
    microchip: getVal(m, "microchip"),
    numero_pasaporte: getVal(m, "numero_pasaporte"),
    propietario: getVal(m, "propietario"),
    veterinario: getVal(m, "veterinario"),
    aseguradora: getVal(m, "aseguradora"),
    pais_emisor: getVal(m, "pais_emisor"),
    fecha_expedicion_pasaporte: getVal(m, "fecha_expedicion_pasaporte"),
    proxima_revacunacion: getVal(m, "proxima_revacunacion"),
    vacunas: getVal(m, "vacunas"),
    desparasitaciones: getVal(m, "desparasitaciones"),
  };
};

export const hasPetData = (analisis) => {
  const d = extractPetData(analisis);
  return !!(d.nombre || d.microchip || d.numero_pasaporte || d.especie || d.raza);
};

// Compara los datos extraídos con una mascota concreta y devuelve las coincidencias.
export const scorePet = (data, pet) => {
  const reasons = [];
  let strong = false;
  if (data.microchip && pet.microchip && normChip(data.microchip) === normChip(pet.microchip)) {
    reasons.push("microchip");
    strong = true;
  }
  if (data.numero_pasaporte && pet.passport_number && norm(data.numero_pasaporte) === norm(pet.passport_number)) {
    reasons.push("pasaporte");
    strong = true;
  }
  const nameEq = data.nombre && pet.name && norm(data.nombre) === norm(pet.name);
  if (nameEq) {
    reasons.push("nombre");
    if (data.especie && pet.species && norm(data.especie) === norm(pet.species)) reasons.push("especie");
    if (data.raza && pet.breed && norm(data.raza) === norm(pet.breed)) reasons.push("raza");
    if (data.fecha_nacimiento && pet.birth_date && data.fecha_nacimiento === pet.birth_date) {
      reasons.push("fecha de nacimiento");
    }
  }
  let confidence = null;
  if (strong) confidence = "alta";
  else if (
    reasons.includes("nombre") &&
    (reasons.includes("especie") || reasons.includes("raza") || reasons.includes("fecha de nacimiento"))
  ) {
    confidence = "media";
  } else if (reasons.includes("nombre")) {
    confidence = "baja";
  }
  return { reasons, strong, confidence, score: (strong ? 100 : 0) + reasons.length };
};

// Devuelve los candidatos ordenados y el mejor match para los datos extraídos.
export const matchPets = (analisis, pets) => {
  const data = extractPetData(analisis);
  if (!hasPetData(analisis) || !pets || pets.length === 0) return { data, candidates: [], best: null };
  const candidates = pets
    .map((pet) => ({ pet, ...scorePet(data, pet) }))
    .filter((c) => c.reasons.length > 0)
    .sort((a, b) => b.score - a.score);
  return { data, candidates, best: candidates[0] || null };
};

// Etiquetas legibles de los campos de la ficha que pueden rellenarse desde un documento.
export const PET_FIELD_LABELS = {
  species: "Especie",
  breed: "Raza",
  sex: "Sexo",
  birth_date: "Fecha de nacimiento",
  microchip: "Nº de microchip",
  passport_number: "Nº de pasaporte",
  insurer: "Seguro / aseguradora",
  vet: "Veterinario habitual",
};

// Calcula los cambios propuestos (nuevos y conflictos) entre la ficha y el documento.
export const computePetUpdates = (data, pet) => {
  const map = {
    species: data.especie,
    breed: data.raza,
    sex: data.sexo,
    birth_date: data.fecha_nacimiento,
    microchip: data.microchip,
    passport_number: data.numero_pasaporte,
    insurer: data.aseguradora,
    vet: data.veterinario,
  };
  const changes = [];
  Object.entries(map).forEach(([field, nuevo]) => {
    if (nuevo == null || String(nuevo).trim() === "") return;
    const actual = pet[field];
    if (actual == null || String(actual).trim() === "") {
      changes.push({ field, label: PET_FIELD_LABELS[field], nuevo, actual: null, conflicto: false });
    } else if (norm(actual) !== norm(nuevo)) {
      changes.push({ field, label: PET_FIELD_LABELS[field], nuevo, actual, conflicto: true });
    }
  });
  return changes;
};
